import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from './HashMap.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EmptyHolderClass;
function EmptyHolder() {
  if (EmptyHolderClass === VOID) {
    class $ {
      constructor() {
        EmptyHolder_instance = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = InternalHashMap().ja(0);
        this_0.ub();
        tmp.xb_1 = LinkedHashMap().ec(this_0);
      }
    }
    initMetadataForObject($, 'EmptyHolder');
    EmptyHolderClass = $;
  }
  return EmptyHolderClass;
}
var EmptyHolder_instance;
function EmptyHolder_getInstance() {
  if (EmptyHolder_instance === VOID)
    new (EmptyHolder())();
  return EmptyHolder_instance;
}
function init_kotlin_collections_LinkedHashMap(_this__u8e3s4) {
}
var LinkedHashMapClass;
function LinkedHashMap() {
  if (LinkedHashMapClass === VOID) {
    class $ extends HashMap() {
      static fc() {
        var $this = this.s8();
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static gc(initialCapacity) {
        var $this = this.g9(initialCapacity);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static hc(original) {
        var $this = this.h9(original);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static ec(internalMap) {
        var $this = this.r8(internalMap);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      g8() {
        this.p8_1.ub();
        var tmp;
        if (this.q2() > 0) {
          tmp = this;
        } else {
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp = EmptyHolder_getInstance().xb_1;
        }
        return tmp;
      }
      p6() {
        return this.p8_1.r9();
      }
    }
    initMetadataForClass($, 'LinkedHashMap', $.fc, VOID, [KtMutableMap()]);
    LinkedHashMapClass = $;
  }
  return LinkedHashMapClass;
}
//region block: exports
export {
  LinkedHashMap as LinkedHashMap1zhqxkxv3xnkl,
};
//endregion

//# sourceMappingURL=LinkedHashMap.mjs.map
